import { type FC } from "react";
import { StyledChip } from "components/Chip/chip.styles.ts";

interface ChipProps {
	label: string;
	visible?: boolean;
}

const Chip: FC<ChipProps> = ({ label, visible }) => {
	if (!visible) return null;

	return (
		<StyledChip
			data-testid="order-details-line-item-status-chip"
			label={label}
			size="small"
			variant="outlined"
		/>
	);
};

export default Chip;
